import React from 'react';

import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiPaper from '@material-ui/core/Paper';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import SplitTrackRow from './split-track-row';

function TableSplits({ trackData }) {
  if (!trackData.length) return <MuiTableContainer component={MuiPaper}></MuiTableContainer>;
  if (trackData.isLoading) return <MuiCircularProgress />;

  return (
    <MuiTableContainer component={MuiPaper}>
      <MuiTable aria-label="collapsible table">
        <MuiTableHead>
          <MuiTableRow>
            <MuiTableCell>id</MuiTableCell>
            <MuiTableCell>Title</MuiTableCell>
            <MuiTableCell>ISRC</MuiTableCell>
            <MuiTableCell>Type</MuiTableCell>
            <MuiTableCell>Splits Locked</MuiTableCell>
            <MuiTableCell align="right"></MuiTableCell>
          </MuiTableRow>
        </MuiTableHead>
        <MuiTableBody>
          {trackData
            .sort((a, b) => a.id - b.id)
            .map(track => (
              <SplitTrackRow key={track.id} track={track} />
            ))}
        </MuiTableBody>
      </MuiTable>
    </MuiTableContainer>
  );
}

export default TableSplits;
